module.exports = "<svg viewBox=\"0 0 32.3 32.1\"><circle cx=\"16.1\" cy=\"16.1\" r=\"4\" class=\"st0\"></circle><path d=\"M0 0v32.1h32.3V0H0zm16.1 25.3c-5.1 0-9.2-4.1-9.2-9.2s4.1-9.2 9.2-9.2 9.2 4.1 9.2 9.2c.1 5.1-4.1 9.2-9.2 9.2zM26.7 7.9c-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4.1 1.3-1 2.4-2.4 2.4z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/instagram.svg
// module id = 296
// module chunks = 1